import { render, staticRenderFns } from "./shipmentContentBlock.vue?vue&type=template&id=c50d36c2"
import script from "./shipmentContentBlock.vue?vue&type=script&lang=js"
export * from "./shipmentContentBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports